import { GlobalResponseObject } from "../../../global-response-object";
import { LineWorkStationReworkModel } from "./line-workstation-rework.model";

export class LineWorkStationReworkResponse extends GlobalResponseObject{
    data?: LineWorkStationReworkModel[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LineWorkStationReworkModel[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}

